import { create } from 'zustand';

interface SetUsernameModalStore {
  isOpen: boolean;
  username: string;
  title?: string;
  ctaText?: string;
  openModal: (params?: {
    title?: string;
    ctaText?: string;
    callbackOnComplete?: (username: string) => void;
  }) => void;
  closeModal: () => void;
  setUsername: (username: string) => void;
  callbackOnComplete?: (username: string) => void;
}

export const useSetUsernameModal = create<SetUsernameModalStore>((set) => ({
  isOpen: false,
  username: '',
  title: undefined,
  ctaText: undefined,
  openModal: (params) =>
    set({
      isOpen: true,
      title: params?.title,
      ctaText: params?.ctaText,
      callbackOnComplete: params?.callbackOnComplete,
    }),
  closeModal: () =>
    set({ isOpen: false, username: '', title: undefined, ctaText: undefined }),
  setUsername: (username) => set({ username }),
}));
